import react from "react";
import { DndProvider as MultiDndProvider } from "react-dnd-multi-backend";
import { HTML5toTouch } from "rdndmb-html5-to-touch";

const DragNDropProvider = ({ children }: { children: react.ReactNode }) => {
  return <MultiDndProvider options={HTML5toTouch}>{children}</MultiDndProvider>;
};

export default DragNDropProvider;
